import React, { useState } from 'react';
import './Inquiry.css';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const Inquiry = () => {
  const [formStatus, setFormStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('sending');
    
    try {
      const formData = new FormData(e.target);
      formData.append('subject', 'New Contact Form Submission');
      formData.append('from_name', formData.get('name'));
      
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });
      
      const result = await response.json();
      
      if (result.success) {
        setFormStatus('success');
        e.target.reset();
      } else {
        console.error('Form submission error:', result);
        setFormStatus('error');
      }
    } catch (error) {
      console.error('Submission error:', error);
      setFormStatus('error');
    }
  };

  return (
    <div className="inquiry-container">
      <div className="inquiry-content">
        <h1>Contact Us</h1>
        
        <div className="inquiry-grid">
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <p>Have a question or need assistance? We're here to help!</p>
            
            <div className="contact-details">
              <div className="contact-item">
                <span className="icon-wrapper">
                  <FaMapMarkerAlt />
                </span>
                <p>70-1, Jalan PJS 11/7, Bandar Sunway<br />47500, Subang Jaya, Selangor</p>
              </div>
              
              <div className="contact-item">
                <span className="icon-wrapper">
                  <FaPhone />
                </span>
                <p>+60 16-286 5881</p>
              </div>
              
              <div className="contact-item">
                <span className="icon-wrapper">
                  <FaEnvelope />
                </span>
                <p>sales@projectpowerbycw.com</p>
              </div>
            </div>
          </div>

          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <input type="hidden" name="access_key" value={process.env.REACT_APP_WEB3FORMS_KEY} />
              <input type="checkbox" name="botcheck" className="hidden" style={{display: 'none'}} />
              
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  placeholder="Your name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  placeholder="Your email"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Your phone number"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  required
                  placeholder="Message subject"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  required
                  placeholder="Your message"
                  rows="5"
                ></textarea>
              </div>

              <button type="submit" className="submit-button" disabled={formStatus === 'sending'}>
                {formStatus === 'sending' ? 'Sending...' : 'Send Message'}
              </button>

              {formStatus === 'success' && (
                <p className="success-message">Thank you! Your message has been sent successfully.</p>
              )}
              {formStatus === 'error' && (
                <p className="error-message">Sorry there was an error sending your message. Please try again.</p>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inquiry;